import CaregiverCash from '@app/features/caregiverCash/CaregiverCash';

const CaregiverCashPage = () => {
  return <CaregiverCash />;
};

export default CaregiverCashPage;
